import { createContext, useContext } from 'react'

export interface SellerTabContextValue {
  openArtistTab: (artistId: number, artistName: string) => void
  openLabelTab: (labelName: string) => void
}

export const SellerTabContext = createContext<SellerTabContextValue | null>(null)

export function useSellerTabContext() {
  return useContext(SellerTabContext)
}
